import { faker } from '@faker-js/faker'
import type { Notification, NotificationType } from '../../types/notification'

const NOTIFICATION_TEMPLATES: Record<NotificationType, { title: string; message: string; link?: string }[]> = {
  order_placed: [
    {
      title: 'Order Placed Successfully',
      message: 'Your order has been placed and is being processed.',
      link: '/orders',
    },
  ],
  order_confirmed: [
    {
      title: 'Order Confirmed',
      message: 'Your order has been confirmed and will be prepared soon.',
      link: '/orders',
    },
  ],
  order_packed: [
    {
      title: 'Order Packed',
      message: 'Your order has been packed and is ready for dispatch.',
      link: '/orders',
    },
  ],
  order_shipped: [
    {
      title: 'Order Shipped',
      message: 'Your order is on its way! Track your delivery.',
      link: '/orders',
    },
  ],
  order_out_for_delivery: [
    {
      title: 'Out for Delivery',
      message: 'Your order is out for delivery and will arrive soon.',
      link: '/orders',
    },
  ],
  order_delivered: [
    {
      title: 'Order Delivered',
      message: 'Your order has been successfully delivered. Enjoy!',
      link: '/orders',
    },
  ],
  order_cancelled: [
    {
      title: 'Order Cancelled',
      message: 'Your order has been cancelled. Refund will be processed.',
      link: '/orders',
    },
  ],
  stock_alert: [
    {
      title: 'Item Back in Stock',
      message: 'Good news! An item from your wishlist is now available.',
      link: '/wishlist',
    },
  ],
  promotional: [
    {
      title: 'Special Offer Just for You!',
      message: 'Get 20% off on all fruits this weekend. Limited time only!',
      link: '/',
    },
    {
      title: 'Flash Sale Alert!',
      message: 'Flash sale on dairy products. Up to 30% off for next 2 hours!',
      link: '/flash-deals',
    },
  ],
  support_reply: [
    {
      title: 'Support Team Replied',
      message: 'Our support team has responded to your query.',
      link: '/support/tickets',
    },
  ],
}

export const generateMockNotification = (overrides?: Partial<Notification>): Notification => {
  const types: NotificationType[] = [
    'order_placed',
    'order_confirmed',
    'order_packed',
    'order_shipped',
    'order_out_for_delivery',
    'order_delivered',
    'stock_alert',
    'promotional',
  ]
  
  const type = (faker.helpers as any).arrayElement(types) as NotificationType
  const templates = NOTIFICATION_TEMPLATES[type]
  const template = (faker.helpers as any).arrayElement(templates)

  return {
    id: faker.string.uuid(),
    type,
    title: template.title,
    message: template.message,
    link: template.link,
    is_read: faker.datatype.boolean({ probability: 0.4 }),
    created_at: faker.date.recent({ days: 30 }).toISOString(),
    ...overrides,
  }
}

export const generateMockNotifications = (count: number = 10): Notification[] => {
  return Array.from({ length: count }, () => generateMockNotification())
}
